import { Button, Descriptions } from 'antd';
import { FC } from 'react';

import type { ArrayElement, BaseQueryParams } from '@/common/interfaces';

import { useSearchAndReplaceHistoryQuery } from '@/modules/Pages';

interface Props {
  historyItem: ArrayElement<BaseQueryParams<typeof useSearchAndReplaceHistoryQuery>['data']>;
  loading: boolean;
  handleRollback: (version: string) => void;
}

export const PagesSearchAndReplaceHistoryInfo: FC<Props> = ({ handleRollback, historyItem, loading }) => {
  return (
    <p>
      <Descriptions
        size="small"
        layout="vertical"
        items={[
          {
            key: 'found',
            label: 'Входження',
            children: historyItem.replacementInfo.search,
          },
          {
            key: 'replaced',
            label: 'Замінено на',
            children: historyItem.replacementInfo.replaceWith,
          },
        ]}
      />
      <br />
      <Button
        variant="solid"
        color="orange"
        loading={loading}
        onClick={() => handleRollback(historyItem.version)}
      >
        Повернути
      </Button>
    </p>
  );
};
